export default __webpack_public_path__ + "static/media/ic_location_sm.ba8fca00.svg";